import debounce from 'lodash/debounce';

const debounceMap = new Map();
const latestTimestampMap = new Map();

export function CreateLatestDebouncedAction({
  keyExtractor,
  handlerFn,
  commitFn,
  delay = 500,
  errorFn,
}) {
  return function vuexAction(context, payload) {
    const key = keyExtractor(payload);
    if (!key) {
      return Promise.resolve({ error: 'Missing key', status: 400 });
    }

    const timestamp = Date.now();
    latestTimestampMap.set(key, timestamp);

    if (!debounceMap.has(key)) {
      debounceMap.set(
        key,
        debounce(async (latestPayload, resolve, ts) => {
          try {
            const result = await handlerFn({ context, payload: latestPayload });

            const latestTimestamp = latestTimestampMap.get(key);
            const isLatest = latestTimestamp === ts;

            if (isLatest) {
              commitFn(context.commit, result);
              resolve({ success: true, status: 200, data: result });
            } else {
              resolve({
                success: false,
                status: 202,
                reason: 'outdated',
                data: result,
              });
            }
          } catch (error) {
            if (errorFn) {
              errorFn(context, latestPayload, error);
            }
            resolve({
              error: error.message || 'Unexpected error',
              status: error.status || 500,
            });
          }
        }, delay)
      );
    }

    return new Promise((resolve) => {
      debounceMap.get(key)(payload, resolve, timestamp);
    });
  };
}

export function flushDebouncedAction(key) {
  const fn = debounceMap.get(key);
  if (fn && typeof fn.flush === 'function') {
    return fn.flush();
  }
  return undefined;
}
